import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { RolesService } from '../services/roles.service'; // << ajuste do caminho

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private roles: RolesService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const requiredRole = route.data['requiredRole'] as string;
    return this.roles.hasRole(requiredRole) ? true : this.router.parseUrl('/issues');
  }
}
